<template>
    <div class="pt-4 mt-4 garniture garniture--supplier">
        <div class="d-flex align-items-center">
            <div class="subtitle1">Гарнитур</div>
            <p class="caption mb-0 pl-2 pt-1 text-gray garniture__number">
                {{ product.garniture.set_article }}
            </p>
        </div>
        <div
            v-if="set && set.set_items.length"
            class="garniture__list d-flex flex-md-wrap align-items-center"
        >
            <div
                v-for="set_item in set.set_items"
                :key="set_item.id"
                class="garniture__item"
            >
                <router-link
                    :to="{
                        name: 'SupplierProductsDetail',
                        params: { id: set_item.item.ItemID }
                    }"
                >
                    <img
                        v-if="set_item.item.images.length"
                        :src="set_item.item.images[0].url"
                        :alt="set_item.item.name"
                    />
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailGarniture',
    props: {
        product: {
            type: Object,
            required: true
        },
        set: {
            /* eslint-disable-next-line */
            type: Object | null,
            required: true
        }
    }
}
</script>
